






import Vue from 'vue'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import {
  ABSENCES_ASSISTANT_GET_COMPANY_FILTER
} from '@/store/getter-types'
import { CompanyFilterValue } from '@/types/payload'
import AbsencesEditorEmployeeSelect from '@/components/absences/absence/employee/AbsencesEditorEmployeeSelect.vue'
import { Absence } from '@/model/absences/Absence'

interface ComponentData {
  availableEmployeeList: EmployeeAvailableForPlanning[]
}

export default Vue.extend({
  name: 'AbsencesEditorEmployee',

  components: {
    AbsencesEditorEmployeeSelect
  },

  props: {
    editAbsence: Object as () => Absence | undefined,
  },

  data (): ComponentData {
    return {
      availableEmployeeList: []
    }
  },

  computed: {
    companyFilter (): CompanyFilterValue {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_COMPANY_FILTER]
    }
  }
})
